<template>
    <div class="billing-center-box">
        <van-nav-bar title="安全中心" />

        <div class="store-admin-content">
            <div class="hhk-item df-csb">
                <div class="left df-c">
                    <van-icon name="graphic" size="24" color="rgb(25, 92, 216)" />
                    <div class="ml10">绑定手机</div>
                </div>
                <div class="right">{{ call }}</div>
            </div>
            <div class="hhk-item df-csb" @click="showPopup">
                <div class="left df-c">
                    <van-icon name="card" size="24" color="rgb(25, 92, 216)" />
                    <div class="ml10">绑定邮箱</div>
                </div>
                <div class="right"><van-icon name="arrow" /></div>
            </div>
        </div>
        <van-dialog v-model="show" title="邮箱" show-cancel-button :before-close="beforClose">
            <van-field v-model="email" name="email" placeholder="请输入邮箱" />
        </van-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            call: '',
            email: ''
        };
    },
    mounted() {
        console.log(JSON.parse(this.$route.query.item))
    },
    methods: {
        showPopup() {
            this.show = true;
        },
        // 异步关闭弹框
        beforClose(action, done) {
            if (action === 'confirm') {
                setTimeout(done, 1000);
            } else {
                done();
            }
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .store-admin-content {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        .hhk-item {
            padding: 15px 10px;
            font-size: 14px;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            background-color: #ffffff;
            .left {
                flex: 1;

                .hhk-item-name {
                    font-size: 16px;
                    margin-right: 10px;
                }
            }
        }
        .hhk-item:active {
            background-color: #eeeeee;
        }
    }

    .email {
        width: 240px;
        padding-top: 10px;
        .title {
            text-align: center;
            font-size: 28px;
        }
        .btn {
            text-align: center;
            border-top: 1px solid #eee;
            padding: 5px 0;
        }
    }
}
</style>
